var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addresses"},[_vm._l((_vm.addresses),function(address){return _c('Address',{key:address.id,staticClass:"edit-address",attrs:{"address":address}})}),_c('Address',{staticClass:"add-address"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }